module.exports = __webpack_public_path__ + "img/mailIcon.5a73fd82.svg";